// Continuous, gentle purple ribbon rain — scoped to the New Beginnings (DV Awareness) page only.
const COUNT = 22;

function seeded(i, salt) {
  const x = Math.sin(i * 99.7 + salt * 12.3) * 10000;
  return x - Math.floor(x);
}

const RIBBONS = Array.from({ length: COUNT }).map((_, i) => {
  const left = seeded(i, 1) * 100;
  const size = 16 + seeded(i, 2) * 26;
  const duration = 11 + seeded(i, 3) * 12;
  const delay = -seeded(i, 4) * duration;
  const opacity = 0.1 + seeded(i, 5) * 0.22;
  const drift = (seeded(i, 6) - 0.5) * 120;
  return { left, size, duration, delay, opacity, drift };
});

export default function RibbonRain() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true" data-testid="dv-ribbon-rain">
      {RIBBONS.map((r, i) => (
        <span
          key={i}
          className="dv-ribbon text-purple-400"
          style={{
            left: `${r.left}%`,
            opacity: r.opacity,
            animationDuration: `${r.duration}s`,
            animationDelay: `${r.delay}s`,
            "--dv-x": `${r.drift}px`,
          }}
        >
          <svg
            width={r.size}
            height={r.size * 1.4}
            viewBox="0 0 64 88"
            fill="none"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M32 4C23 17 23 30 32 42C41 30 41 17 32 4Z" />
            <path d="M27 39L17 82" />
            <path d="M37 39L47 82" />
          </svg>
        </span>
      ))}
    </div>
  );
}
